<button class="spinner-button" id="{{field.id}}__spinUp" (click)="stepSpinner(true)">▲</button>
<button class="spinner-button" id="{{field.id}}__spinDown" (click)="stepSpinner(false)">▼</button>
